import { useContext } from 'react';
import { Formik, Form } from 'formik';
import { CircleLoader, Page, PageHeader } from 'components';
import { customerNewTicketContext } from './CustomerNewTicketContext';
import { NewTicketForm } from './components';
import { Container } from '@mui/material';
import { customerApplicationContext, appUserContext } from 'helpers/services';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';

let NewTicket = () => {
    let { formatMessage } = useIntl();
    let service = useContext(customerNewTicketContext);
    let { currentUser } = useContext(appUserContext);
    let appService = useContext(customerApplicationContext);

    return (
        <Container maxWidth="md">
            <Page title={formatMessage({ id: LocalizationIds.NewTicket })}>
                <PageHeader pageTitle={formatMessage({ id: LocalizationIds.NewTicket })} />
                <Formik
                    enableReinitialize={true}
                    validationSchema={service.newTicketSchema}
                    initialValues={{
                        ...service.newTicketSchema.getDefault(),
                        categoryId: appService.ticketCategories[0].ticketCategoryId,
                        reporterUserName: currentUser.email
                    }}
                    onSubmit={(values, action) => {
                        service.saveNewTicket(values as any);
                        action.setSubmitting(false);
                    }}
                >
                    <Form>
                        {service.isLoading && <CircleLoader />}
                        {service.isLoading === false && <NewTicketForm />}
                    </Form>
                </Formik>
            </Page >
        </Container >
    );
}

export default NewTicket;